import SyDaywiseEventList from "./sy-event-calendar-list";

export default SyDaywiseEventList;
